import React from 'react';
import PropTypes from 'prop-types';
import './GoogleAuthButton.scss';

export default function GoogleAuthButton({ disabled, onClick, isSignup }) {
  return (
    <div
      role="button"
      tabIndex="0"
      onClick={onClick}
      disabled={disabled}
      className="GoogleAuthButton"
    >
      <img
        src={isSignup ? 'Sign up with Google' : 'Sign in with Google'}
        src={isSignup ? '/images/google_sign_up.png' : '/images/google_sign_in.png'}
        width="100%"
        height="100%"
      />
    </div>
  );
}

GoogleAuthButton.propTypes = {
  disabled: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  isSignup: PropTypes.bool,
};

GoogleAuthButton.defaultProps = {
  isSignup: false,
};



// WEBPACK FOOTER //
// ./src/components/GoogleAuthButton/GoogleAuthButton.jsx